import { useIntl } from 'react-intl';
import { agentDisplayName } from '@constants/agentNames';

/**
 * Label for a skill load, shared by the live setup block and the durable
 * transcript entry so both name the skill the same way. A custom skill is not
 * in the display-name map — its id is its name, so it falls back to title case.
 */
export const useSkillLoadLabel = (skill: string | undefined, done: boolean): string => {
  const intl = useIntl();
  const name = skill ? agentDisplayName(skill) : undefined;

  if (!name) {
    return intl.formatMessage({
      id: done ? 'tool.load_skill.loadedGeneric' : 'tool.load_skill.loadingGeneric',
    });
  }
  return intl.formatMessage(
    { id: done ? 'tool.load_skill.loaded' : 'tool.load_skill.loading' },
    { skill: name },
  );
};
